import React from 'react';
import { useAuth } from '../hooks/useAuth';
import LoginScreen from '../pages/LoginScreen';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isInitialized } = useAuth();

  // Render nothing while the auth check is still in flight — avoids a flash
  // of the login screen for users with an existing Microsoft session.
  if (!isInitialized) {
    return null;
  }

  if (!isAuthenticated) {
    return <LoginScreen />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
